import {
  can,
  canAt,
  isFeatureEnabled,
  isFeatureEnabledAt,
  splitPermission,
  type FeatureKey,
  type Permission,
  type PolicySubject,
} from "@alm/policy";

// Company settings (API keys, phone accounts): with no building named, a building role answers only
// if it runs the company (`runsTheCompany`).
function companySetting(permission: Permission): boolean {
  const { resource, action } = splitPermission(permission);
  return resource === "settings" && action !== "read";
}

// facilityId left out: at `here` (null = all the person's buildings); null: as the API answers a
// request naming no building; an id: at that building. A role held at another building opens
// nothing at this one.
export function canHere(
  subject: PolicySubject,
  permission: Permission,
  here: string | null,
  facilityId?: string | null,
): boolean {
  if (facilityId !== undefined) return can(subject, permission, { facilityId });
  if (companySetting(permission)) return can(subject, permission);
  return canAt(subject, permission, here);
}

// As `canHere`, except left out with all buildings in view means on at any of them, as the
// navigation shows it; null is the organization's switch.
export function featureHere(
  subject: PolicySubject,
  key: FeatureKey,
  here: string | null,
  facilityId?: string | null,
): boolean {
  if (facilityId !== undefined) return isFeatureEnabled(subject, key, { facilityId });
  return isFeatureEnabledAt(subject, key, here);
}
